export const SELECT_AD_TYPE_CY = {
  OPEN_MODAL_BTN: 'open-modal-btn',
  MODAL: 'select-ad-modal',
  OVERLAY: 'select-ad-overlay',
  CLOSE_BTN: 'ad-type-modal-close-btn',
  AD_TYPE: (key: string) => `select-ad-type-item-${key}`
};

export const PAYMENT_MODAL_CY = {
  MAIN_MODAL: 'payments-modal',
  OPEN_PROMOTE_BTN: 'open-promote-modal',
  CONFIRM_BTN: 'confirm-payment',
  SUCCESS_TOP_UP_MODAL: 'payment-top-up-success-modal',
  MODAL_OVERLAY: 'modal-overlay',
  PAYMENT_METHOD: (id: string | number) => `promote-ad-payment-method-${id}`,
  AMOUNT_CHIP: (id: string) => `amount-chip-${id}`,
  DEPOSIT_INPUT: 'deposit-input',
  TOP_UP_BTN: 'top-up-btn',
  ERROR_TOP_UP_MODAL: 'error-top-up-modal'
};
